import styled from 'styled-components';
import ButtonSelector from './ButtonSelector';
import { colorSchema } from 'utils/style';

export default styled(ButtonSelector)`
  .button-selector {
    display: flex;
    flex-direction: column;

    &__item {
      width: 100%;
      opacity: ${props => (props.disabled ? `.5` : '1')};
      pointer-events: ${props => (props.disabled ? `none` : 'auto')};
    }

    &__item-label {
      align-items: center;
      border-radius: 4px;
      border: 1px solid ${colorSchema('grey300')};
      cursor: pointer;
      display: flex;
      margin-bottom: 0.8rem;
      padding: 1.4rem;
      width: 100%;
    }

    &__item-icon {
      margin-right: 3rem;

      svg {
        fill: ${colorSchema('grey700')};
      }
    }

    &__item-text {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
    }

    &__item-input {
      display: none;

      &:checked + label {
        border: 1px solid ${colorSchema('primary300')};

        .button-selector__item-text {
          color: ${colorSchema('grey900')};
          font-weight: bold;
        }

        .button-selector__item-icon {
          svg {
            fill: ${colorSchema('grey900')};
          }
        }
      }
    }
  }
`;
